module.exports = __webpack_public_path__ + "005beaebed4420d8acb71932d3b8ec3a.png";